module.exports = __webpack_public_path__ + "static/media/Prizes.dda6e7d4.jpg";